// extracted by mini-css-extract-plugin
module.exports = {"container":"ObserverWindow_container__yPD6c","readingMode":"ObserverWindow_readingMode__fiRzr"};